<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col cols="12" md="8">
                <v-card flat>
                    <v-card-text>
                        <v-form>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                            outlined
                                            label="Report Name"
                                            v-model="$v.editedItem.name.$model"
                                            :error-messages="reportNameError"
                                            error-count=2
                                            hint="ie. Driver License"
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="3">
                                    <v-row>
                                        <v-col cols="12">
                                            <v-switch label="Report is Required"
                                                      v-model="$v.editedItem.required.$model">
                                            </v-switch>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-switch label="Report requires approval"
                                                      v-model="$v.editedItem.approvalRequired.$model">
                                            </v-switch>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-switch label="Report requires log hours"
                                                      v-model="$v.editedItem.requiredLogHours.$model">
                                            </v-switch>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="1" class="d-none d-md-flex">
                                    <v-divider vertical inset></v-divider>
                                </v-col>
                                <v-col xs="12" md="8">
                                        <v-row>
                                            <v-col sm-12 md-3>
                                                <v-select
                                                        label="Every"
                                                        outlined
                                                        :items="getSelectorEvery"
                                                        :value="reportFrequency.every"
                                                        @change="$v.reportFrequency.every.$model = $event"
                                                ></v-select>
                                            </v-col>
                                            <v-col sm-12 md-3>
                                                <v-select
                                                        :label="reportFrequency.frequency"
                                                        outlined
                                                        :items="reportFrequency.selectorFrequency"
                                                        :value="reportFrequency.frequency"
                                                        @change="reportFrequency.frequency = $event"
                                                >
                                                </v-select>
                                            </v-col>
                                            <v-col sm-12 md-3 v-if="(reportFrequency.every !== frequencies.EVERY && reportFrequency.frequency === frequencies.MONTH) || reportFrequency.frequency === frequencies.YEAR">
                                                <v-select
                                                        :error-messages="reportFrequencyMonthError"
                                                        :label="reportFrequency.frequency === frequencies.YEAR ? 'On Month' : 'Starting On'"
                                                        outlined
                                                        :items="selectorMonth"
                                                        :value="reportFrequency.month"
                                                        @change="$v.reportFrequency.month.$model = $event"
                                                >
                                                </v-select>
                                            </v-col>
                                            <v-col sm-12 md-3 v-if="reportFrequency.frequency === frequencies.MONTH || reportFrequency.frequency === frequencies.YEAR || reportFrequency.frequency === frequencies.WEEK">
                                                <v-select
                                                        :error-messages="reportFrequencyDayError"
                                                        label="On Day"
                                                        outlined
                                                        :items="reportFrequency.frequency === frequencies.WEEK ? selectorWeekDays : selectorMonthDays"
                                                        :value="reportFrequency.day"
                                                        @change="$v.reportFrequency.day.$model = $event"
                                                >
                                                </v-select>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-col cols="6" sm="2">
                                    <v-btn color="default" text @click="close">Cancel</v-btn>
                                </v-col>
                                <v-col cols="6" sm="2">
                                    <v-btn color="primary"
                                           :loading="isSaving"
                                           :disabled="isSaving"
                                           @click="save">Save</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <dialog-alert :text="alertText"
                      :alert-type="alertType"
                      :open="openAlert"
                      @alert-closed="alertClosed($event)">
        </dialog-alert>
        <dialog-alert :text="notFoundError"
                      :alert-type="alertTypes.ERROR"
                      :open="openNotFound"
                      @alert-closed="close()">
        </dialog-alert>
    </v-container>
</template>

<script>
    import alertEventBus from '@/eventBus/AlertEventBus';
    import { required, maxLength, minLength, requiredIf, between} from 'vuelidate/lib/validators';
    import {DocumentRule} from '@/shared/dtos/Dtos';
    import {DOCUMENT_RULE_TYPES} from "@/shared/enums/DocumentRule";
    import { FORM_STATUS } from '@/shared/enums/FormStatuses';
    import {FREQUENCIES, WEEK_DAYS} from "@/shared/enums/Report";
    const datePicker = ()=> import( '@/components/common/DatePicker');
    const DialogAlert = ()=> import( '@/components/common/DialogAlert');
    import {formUnsavedMixin} from "@/shared/mixins/FormUnsaved";
    import { ALPHA_NUMERIC_WITH_SPACES_VALIDATOR } from "@/shared/validators/Validators";
    import {WRONG_ID_SUPPLIED}  from "@/shared/enums/AlertTexts";
    import {ALERT_TYPES} from "@/shared/enums/AlertTexts";
    import moment from 'moment';

    export default {
        name: "reportRuleForm",
        mixins:[formUnsavedMixin],
        props:['id'],
        components:{
            datePicker, DialogAlert
        },
        data(){
            return {
                editedItem: {},
                reportFrequency: {
                    every: FREQUENCIES.EVERY,
                    selectorFrequency:FREQUENCIES.availableFrequencies(),
                    frequency:FREQUENCIES.MONTH,
                    day:'',
                    month:''
                },
                isSaving: false,
                notFoundError: WRONG_ID_SUPPLIED,
                openNotFound: false,
                alertTypes: ALERT_TYPES,
                reportRuleType: DOCUMENT_RULE_TYPES,
                moment: moment
            };
        },
        validations: {
            editedItem:{
                name: {
                    required: required,
                    minLength: minLength(2),
                    ALPHA_NUMERIC_WITH_SPACES_VALIDATOR
                },
                required: {},
                approvalRequired: {},
                requiredLogHours: {}
            },
            reportFrequency: {
                every: {},
                month: {
                    required: requiredIf(function () {
                        return this.isMonthFrequencyRequired();
                    }),
                },
                day:{
                    required: requiredIf(function () {
                        return this.isDayFrequencyRequired();
                    }),
                }
            },
        },
        computed:{
            frequencies(){
                return FREQUENCIES;
            },
            getSelectorEvery(){
                let every = [this.frequencies.EVERY];

                for(let i = 1; i <= 30; i++)
                {
                    every.push(i);
                }

                return every;
            },
            reportNameError(){
                const errors = [];
                if (!this.$v.editedItem.name.$dirty) {
                    return errors;
                }

                !this.$v.editedItem.name.minLength && errors.push('Name must be at least '+
                    this.$v.editedItem.name.$params.minLength.min +' characters long');
                !this.$v.editedItem.name.required && errors.push('Name is required.');
                !this.$v.editedItem.name.ALPHA_NUMERIC_WITH_SPACES_VALIDATOR && errors.push('Name must contain only letters and numbers.');

                return errors;
            },
            reportFrequencyDayError(){
                const errors = [];
                if (!this.$v.reportFrequency.day.$dirty) {
                    return errors;
                }

                !this.$v.reportFrequency.day.required && errors.push('Field is required.');

                return errors;
            },
            reportFrequencyMonthError(){
                const errors = [];
                if (!this.$v.reportFrequency.month.$dirty) {
                    return errors;
                }

                !this.$v.reportFrequency.month.required && errors.push('Field is required.');

                return errors;
            },
            selectorMonthDays(){
                let days = [];
                let lastDay = 31;

                if(this.reportFrequency.frequency === this.frequencies.MONTH && this.reportFrequency.month !== '')
                {
                    lastDay = this.moment(this.reportFrequency.month, "MMMM").daysInMonth();
                }

                return Array(lastDay).fill().map((v,i) => i + 1);
            },
            selectorWeekDays(){
                return WEEK_DAYS.getWeekDays();
            },
            selectorMonth(){
                return moment.months();
            },
            frequencySelected(){
                return this.reportFrequency.frequency;
            }
        },
        watch:{
            frequencySelected(){
                this.reportFrequency.day = '';
            }
        },
        methods:{
            async initialize(){

                this.editedItem = {...DocumentRule};
                this.editedItem.type = this.reportRuleType.REPORT;

                if(this.id !== undefined)
                {
                    await this.$store.dispatch('getDocumentRule',{id: this.id});
                    this.editedItem = this.$store.getters.getDocumentRule;

                    if(this.editedItem.hasOwnProperty('id'))
                    {
                        delete this.editedItem.id;
                        this.editedItem.name = '';

                        this.reportFrequency.every = this.editedItem.notificationInterval.every;
                        this.reportFrequency.frequency = this.editedItem.notificationInterval.frequency;

                        if(this.editedItem.notificationInterval.hasOwnProperty('month'))
                            this.reportFrequency.month = this.editedItem.notificationInterval.month;

                        if(this.editedItem.notificationInterval.hasOwnProperty('day'))
                            this.reportFrequency.day = this.editedItem.notificationInterval.day;
                    }
                    else
                    {
                        this.openNotFound = true;
                        return;
                    }
                }
            },
            close(){
                this.resetValues();
                this.status = FORM_STATUS.CLOSE;

                //going to redirect route
                if(this.$route.query.redirect !== undefined && this.$route.query.redirect !== '')
                {
                    this.$router.push({name:this.$route.query.redirect});
                    return;
                }

                this.$router.push({name: 'reportTable'})
            },
            resetValues(){
                this.$v.$reset();
                this.editedItem = {...DocumentRule};
                this.$store.commit('setDocumentRule',{});
            },
            isDayFrequencyRequired(){
                let dayContained = (this.reportFrequency.frequency === this.frequencies.WEEK && !this.selectorWeekDays.includes(this.reportFrequency.day))
                                   || this.reportFrequency.frequency !== this.frequencies.DAY


                return this.reportFrequency.frequency !== this.frequencies.DAY && dayContained;
            },
            isMonthFrequencyRequired(){
                return (this.reportFrequency.every !== this.frequencies.EVERY && this.reportFrequency.frequency === this.frequencies.MONTH) || this.reportFrequency.frequency === this.frequencies.YEAR;
            },
            async save(){

                this.$v.$touch();

                if(this.$v.$anyError)
                    return;

                this.isSaving = true;

                this.editedItem.notificationInterval = {
                    frequency: this.reportFrequency.frequency,
                    every: this.reportFrequency.every
                };

                if(this.isMonthFrequencyRequired()) this.editedItem.notificationInterval.month = this.reportFrequency.month;
                if(this.isDayFrequencyRequired()) this.editedItem.notificationInterval.day = this.reportFrequency.day;

                try
                {
                    await this.$store.dispatch('setDocumentRule',this.editedItem);
                    let response = this.$store.getters.getDocumentRule;

                    /**
                     * Updating list of report rules
                     */
                    this.$store.commit('setDocumentRules',[]);
                }
                catch (e) {
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    this.isSaving = false;
                    return;
                }

                this.close();
            }
        },
        async created(){
            this.initialize();
        }
    }
</script>

<style>
    .v-chip.white-span span {
        color: white !important;
    }
</style>